import { dateUtils } from "../utils/DateUtils";
import { abstractEntityService } from "./AbstractEntityService";
import { restService } from "./RestService";

export class SearchService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }

    /**
     * Handles searching for available rooms based on propertyId, checkin, checkout, and occupancy
     * @param {string|number} propertyId - ID of the property (used in URL path and body)
     * @param {Date} checkin - Check-in date
     * @param {Date} checkout - Check-out date
     * @param {number} occupancy - Number of adults in the room
     * @returns {Promise<any>} - Search result data
     */
    async search(propertyId, checkin, checkout, occupancy) {
        const url = `${this.baseUrl}/properties/${propertyId}/search`;

        const body = {
            propertyId,
            checkin: dateUtils.getDateString(checkin),
            checkout: dateUtils.getDateString(checkout),
            adults: occupancy
        };

        try {
            const data = await restService.post(url, body);
            return data;
        } catch (error) {
            abstractEntityService.handleError(error, "Unable to perform search - please see server logs for more details");
        }
    };
}